import { render, staticRenderFns } from "./OrganizationAdd.vue?vue&type=template&id=8266804a"
import script from "./OrganizationAdd.vue?vue&type=script&lang=js"
export * from "./OrganizationAdd.vue?vue&type=script&lang=js"
import style0 from "./OrganizationAdd.vue?vue&type=style&index=0&id=8266804a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports